import { create } from 'zustand';

type KnowledgeDatabasesPageStore = {
  isCreateDialogOpen: boolean;
  openCreateDialog: () => void;
  closeCreateDialog: () => void;
};

export const useKnowledgeDatabasesPageStore =
  create<KnowledgeDatabasesPageStore>((set) => ({
    isCreateDialogOpen: false,
    openCreateDialog: () => set({ isCreateDialogOpen: true }),
    closeCreateDialog: () => set({ isCreateDialogOpen: false }),
  }));
